import Homepage from './Homepage';
import Supplies from "./Supplies";
import Dashboard from './Dashboard';
import Reports from './Reports';

export default {
    Homepage,
    Supplies,
    Dashboard,
    Reports
};
